export default __webpack_public_path__ + "static/media/filters-active.f6c78676.svg";